import { render, staticRenderFns } from "./LayoutAdmin.vue?vue&type=template&id=b0f8e568&scoped=true&lang=pug&"
import script from "./LayoutAdmin.vue?vue&type=script&lang=js&"
export * from "./LayoutAdmin.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAdmin.vue?vue&type=style&index=0&id=b0f8e568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f8e568",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuAdmin: require('/home/node/components/layoutAdmin/MenuAdmin.vue').default,HeaderAdmin: require('/home/node/components/layoutAdmin/HeaderAdmin.vue').default,CookiesSnackbar: require('/home/node/components/shared/CookiesSnackbar.vue').default})
